import { enums, isStatusAfterStatus } from "@fraction/shared";
import { Route, Routes, useParams } from "react-router-dom";
import { AppChat } from "src/components/AppChat";
import { AppChatContainer } from "src/components/AppChatContainer";
import { AppDetailsOverview } from "src/components/AppDetailsOverview";
import { AppDocumentList } from "src/components/AppDocumentList";
import { AppDocumentUpload } from "src/components/AppDocumentUpload";
import { AppOverviewShell } from "src/components/AppOverviewShell";
import { useApplicationAuthed } from "src/hooks/useApplication";

/**
 * inner tabs w/ routes
 */
export function LenderAppOverviewShell() {
  const { id } = useParams();

  const { data: app, isLoading: loading } = useApplicationAuthed({
    id,
    initialRefetch: true,
    refetch: true,
    accountType: "lender",
  });

  return (
    <>
      <AppOverviewShell
        showApproveReject
        app={app || undefined}
        loading={loading}
        tabs={["overview", "doc-upload", "doc-list"]}
      />
      <AppChatContainer loading={loading}>
        {app?.conveyancerGroupId &&
        app?.status &&
        isStatusAfterStatus(app.status, enums.ApplicationStatus.CONVEYANCER_ENGAGED, true) ? (
          <AppChat
            textBoxClassName="h-[400px]"
            className="shadow"
            applicationId={app?.id}
            type={enums.ChatType.LENDER_CONVEYANCER}
          />
        ) : null}
        <AppChat
          title="Chat with Fraction about this deal"
          textBoxClassName="h-[400px]"
          className="shadow"
          applicationId={app?.id}
          type={enums.ChatType.LENDER_EMPLOYEE}
        />
        <AppChat
          title="Chat with both Fraction and the broker"
          textBoxClassName="h-[400px]"
          className="shadow"
          applicationId={app?.id}
          type={enums.ChatType.LENDER_BROKER_EMPLOYEE}
        />
      </AppChatContainer>
    </>
  );
}

export function AppDetailsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LenderAppOverviewShell />}>
        <Route path="/" element={<AppDetailsOverview />} />
        <Route path="/doc-upload" element={<AppDocumentUpload />} />
        <Route path="/doc-list" element={<AppDocumentList mutatable />} />
      </Route>
    </Routes>
  );
}
